import BaseModel from "@/lib/models/BaseModel";
import PortfolioMove from "@/lib/models/PortfolioMove";
import PriceUpdate from "@/lib/models/PriceUpdate";
import {defaultCurrency} from "@/lib/models/sumbols";
import DataSnapshot = firebase.database.DataSnapshot;

export default class Portfolio extends BaseModel {
    private _id: string = "";
    private _name: string = "";
    private _logoUrl: string = "";
    private _showTitle: boolean = true;
    private _color: string = "#f7f7f7";
    private _createdAt: string = "";
    private _moves: Array<PortfolioMove> = [];
    private _priceUpdates: Array<PriceUpdate> = [];
    private _idDefaultPaymentAccount: string | null = null;
    private _currency: { [k: string]: string | number } | null = null;


    public totalInvested() {
        return this.moves.reduce((p, c) => {
            return p + Number(c.price) + Number(c.fee);
        }, 0)
    }

    public latestPriceUpdate(): null | PriceUpdate {
        const priceUpdates = this.priceUpdates.sort((a, b) => {
            return a.date < b.date ? -1 : 1
        }).slice(-1).pop();

        if (priceUpdates) {
            return priceUpdates;
        } else {
            return null;
        }
    }

    public latestUpdateValue(): number {
        const latestPrice = this.latestPriceUpdate();
        if (latestPrice !== null) {
            return latestPrice.price as number;
        } else {
            return 0;
        }
    }

    public fromObject(jsonObj: object, arrayProperties: { [k: string]: (item: {}, key?: string | number) => BaseModel } = {}, id?: string): Portfolio {
        return super.fromObject(jsonObj, {
            _moves: ((item, key) => {
                return (new PortfolioMove()).fromObject(Object.assign({}, item, {
                    id: key
                }));
            }),
            _priceUpdates: ((item, key) => {
                return (new PriceUpdate()).fromObject(Object.assign({}, item, {
                    id: key
                }));
            }),
        }, id) as Portfolio;
    }

    get hasLogo(): boolean {
        return this.logoUrl !== undefined && this.logoUrl !== null && this.logoUrl.length > 5;
    }

    get id(): string {
        return this._id;
    }

    set id(value: string) {
        this._id = value;
    }

    get idDefaultPaymentAccount(): string | null {
        return this._idDefaultPaymentAccount;
    }

    set idDefaultPaymentAccount(value: string | null) {
        this._idDefaultPaymentAccount = value;
    }

    get name(): string {
        return this._name;
    }

    set name(value: string) {
        this._name = value;
    }

    get createdAt(): string {
        return this._createdAt;
    }

    set createdAt(value: string) {
        this._createdAt = value;
    }

    get priceUpdates(): Array<PriceUpdate> {
        return this._priceUpdates;
    }

    set priceUpdates(value: Array<PriceUpdate>) {
        this._priceUpdates = value;
    }

    get moves(): Array<PortfolioMove> {
        return this._moves;
    }

    set moves(value: Array<PortfolioMove>) {
        this._moves = value;
    }

    get color(): string {
        return this._color;
    }

    set color(value: string) {
        this._color = value;
    }

    get logoUrl(): string {
        return this._logoUrl;
    }

    set logoUrl(value: string) {
        this._logoUrl = value;
    }

    get showTitle(): boolean {
        return this._showTitle;
    }

    set showTitle(value: boolean) {
        this._showTitle = value;
    }

    get currency(): { [p: string]: string | number } | null {
        return this._currency;
    }

    set currency(value: { [p: string]: string | number } | null) {
        this._currency = value;
    }

}
